export default __webpack_public_path__ + "static/media/e.73366f8d.svg";